import React from 'react';
import { ClassAssembly10A2026 } from '../views';

const ClassAssemblyPage = () => {
    return <ClassAssembly10A2026 />;
  };
  
  export default ClassAssemblyPage;